// Returns a single rgb color interpolation between given rgb color
// based on the factor given; via https://codepen.io/njmcode/pen/axoyD?editors=0010
function interpolateColor(color1, color2, factor) {
    if (arguments.length < 3) { 
        factor = 0.5; 
    }
    var result = color1.slice();
    for (var i = 0; i < 3; i++) {
        result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
    }
    return result;
};

// My function to interpolate between two colors completely, returning an array
function interpolateColors(steps, reverse) {
    var stepFactor = 1 / (steps - 1),
        interpolatedColorArray = [],
        colors = [
            "rgb(169, 211, 33)", 
            "rgb(237, 26, 59)"
        ],
        color1 = colors[0].match(/\d+/g).map(Number),
        color2 = colors[1].match(/\d+/g).map(Number);

    if(reverse) {
        color1 = colors[1].match(/\d+/g).map(Number);
        color2 = colors[0].match(/\d+/g).map(Number);
    }

    for(var i = 0; i < steps; i++) {
        interpolatedColorArray.push(interpolateColor(color1, color2, stepFactor * i));
    }

    return interpolatedColorArray;
}

export default interpolateColors;